<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Errores
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12)
        v-card(color='', style="border-radius:5px;background-color: black;height:80px")
            v-card-title.justify-center
              img(src='../assets/logo3.png', with='50' ,height='50')
        v-card(color='', style="border-radius:5px;background-color: #d6d6d6")
            v-card-title(style="padding: 7px;").justify-center
                span.black--text  Administración de Errores
        v-layout(align-start='', justify-start='', row='', fill-height='')
            v-flex(xs12 style='margin-top: 5px;')
                v-layout(wrap)
                    v-flex(xs4)
                        v-text-field(v-model='search2', prepend-icon='search', label='Buscar')
                    v-flex(xs3)
                        v-select(:items="empresas" v-model="empresaSel" prepend-icon="chevron_right" label="Seleccione Empresa:")
                    v-flex(xs2)
                        v-menu(ref='menu1', v-model='menu1', :close-on-content-click='false', :return-value.sync='dateStart', transition='scale-transition', offset-y, min-width='290px', dark)
                            template(v-slot:activator='{ on, attrs }')
                                v-text-field(v-model='dateStart', label='Fecha Inicio', prepend-icon='event', readonly, v-bind='attrs', v-on='on', clearable, @click:clear='clearDates', color='black', style='margin-right: 10px;')
                            v-date-picker.white--text(v-model='dateStart', no-title, scrollable, :show-current='true', dark, color='white', style='color: white !important;')
                                template(v-slot:year='{ year }')
                                    span.white--text {{ year }}
                                template(v-slot:header='{ value }')
                                    span.white--text {{ value }}
                                div.d-flex.justify-end.pa-2
                                    v-btn(text, color='black', @click='cancelDate(1)') Cancel
                                    v-btn(text, color='black', @click='saveDate(1)') OK
                    v-flex(xs2)
                        v-menu(ref='menu2', v-model='menu2', :close-on-content-click='false', :return-value.sync='dateEnd', transition='scale-transition', offset-y, min-width='290px', dark)
                            template(v-slot:activator='{ on, attrs }')
                                v-text-field(v-model='dateEnd', label='Fecha Fin', prepend-icon='event', readonly, v-bind='attrs', v-on='on', clearable, @click:clear='clearDates', color='black', style='margin-right: 10px;')
                            v-date-picker.white--text(v-model='dateEnd', no-title, scrollable, :show-current='true', dark, color='white', style='color: white !important;')
                                template(v-slot:year='{ year }')
                                    span.white--text {{ year }}
                                template(v-slot:header='{ value }')
                                    span.white--text {{ value }}
                                div.d-flex.justify-end.pa-2
                                    v-btn(text, color='black', @click='cancelDate(2)') Cancel
                                    v-btn(text, color='black', @click='saveDate(2)') OK
                    v-flex(xs1 v-if='dateStart && dateEnd')
                      v-btn.mx-0(icon @click='buscarPorFechas' style='background: white;border-radius: 100%;margin-top: 5px;').elevation-4
                        v-icon(color='#ff6500' style='font-size: 1.70rem;') search
                v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;margin-top: 10px;")
                    v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                        span.white--text Lista de Errores
                v-data-table.elevation-1(:headers='headers', :items="errores", :search='search2' style="margin-top: 5px;", hide-actions, :pagination.sync="pagination")
                    template(slot='items', slot-scope='props')
                        td(v-if='props.item.empresa && props.item.empresa.nombre') {{ props.item.empresa.nombre }}
                        td(v-else) N/A
                        td(v-if='props.item.telefono') {{ props.item.telefono }}
                        td(v-else) N/A
                        td(v-if='props.item.tipo') {{ props.item.tipo }}
                        td(v-else) N/A
                        td(v-if='props.item.fecha') {{ props.item.fecha | moment('DD-MM-YYYY H:mm A') }}
                        td(v-else) N/A
                        td.justify-start.layout.px-0
                          v-tooltip(bottom)
                            template(v-slot:activator='{ on }')
                              v-icon.mr-2(@click='viewSMS(props.item)' v-on="on" color='black') visibility
                            | Ver SMS
                v-card
                    v-flex(xs12)
                        v-layout(wrap='')
                            v-flex(xs6)
                            v-flex(xs5 style='display: flex;justify-content: flex-end;align-items: center;')
                                div(style='margin: 10px;')
                                    span {{skip}} a {{max}} elementos de {{total}}
                                div(style='margin: 2px;')
                                    v-btn.mx-0(id='prev' icon, @click='prev()', style='background: gainsboro;border-radius:50%;' hidden)
                                        v-icon(color='black' style='font-size: 1.8rem;') arrow_left
                                div(style='margin: 2px;' v-for='(item,index) in listado')
                                    v-btn.mx-0(:id='"num"+item', @click='seleccion(item)' icon, style='background: gainsboro;border-radius:50%;')
                                        span(style='font-weight: bold;color:black;') {{item}}
                                div(style='margin: 2px;')
                                    v-btn.mx-0(id='next' icon, @click='next()', style='background: gainsboro;border-radius:50%;')
                                        v-icon(color='black' style='font-size: 1.8rem;') arrow_right
                            v-flex(xs1)
                            v-flex(xs11 style='display: flex;justify-content: flex-end;')
                                v-flex#sll(xs2 style='display: flex;justify-content: flex-end;align-items: center;margin-right: 17px;')
                                    v-select(id="paginas"
                                    outline
                                    @change='seleccion(selpag)'
                                    :items="paginas"
                                    v-model="selpag"
                                    dense
                                    required
                                    label="Página:")
        //===========================================================Modal SMS==============================================================================================
        v-dialog(v-model='dialog2', persistent max-width='600px' style='background:#f1f2f1')
          v-container(style='max-width: 600px;background:#f1f2f1')
            div(style="margin-top: 20px;")
              v-flex(xs12 sm12)
                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                  v-flex(xs12)
                    v-card-title(style="padding: 7px;").justify-center
                      h4.black--text  SMS
                  v-flex(xs12)
                    v-textarea(outline v-model='sms' readonly)
                  v-flex(xs12 style='display: flex;justify-content: center;')
                    v-btn(style="background:black;;border-radius:10px;", @click.native='dialog2 = false, sms = ""') Salir
        //===========================================================Snackbar==============================================================================================
        v-snackbar(v-model='snackbar.show', :color='snackbar.color', :timeout='3000', top)
          | {{ snackbar.message }}
          template(v-slot:action='{ attrs }')
            v-btn(text, v-bind='attrs', @click='snackbar.show = false') Cerrar
        
        //===========================================================Modal Espera==============================================================================================
        v-dialog(v-model='dialog3', persistent max-width='400px' style='background:#f1f2f1')
            v-container(style='max-width: 400px;background:#f1f2f1')
                div(style="margin-top: 20px;")
                    v-flex(xs12 sm12)
                        v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                            v-flex(xs12)
                                v-card-title(style="padding: 7px;").justify-center
                                    h4.black--text  Esperando Respuesta del Servidor.!!
                            v-flex(xs12)
                                div(style='display: flex;justify-content: center;').text-xs-center
                                    img(src='../assets/waiting.gif', with='200' ,height='150')
                            v-flex(xs12)
                                v-card-title(style="padding: 7px;").justify-center
                                    h5.black--text  Por favor espere...
</template>

<script>
import Api from "@/services/methods";
import { server, port } from "@/services/environment";
export default {
  name: "mErrores",
  data: () => ({
    snackbar: {
      show: false,
      message: '',
      color: 'error'
    },
    ruta: server + ":" + port,
    dialog3: false,
    menu1: false,
    menu2: false,
    dateStart: null,
    dateEnd: null,
    pagination: {
      sortBy: 'fecha',
      descending: true,
      rowsPerPage: 20
    },
    skip: 0,
    empresaSel: null,
    empresas: [],
    search2: "",
    dialog2: false,
    max: 0,
    total: 0,
    sms: "",
    actual: 0,
    selpag: "",
    paginas: [],
    listado: [],
    errores: [],
    headers: [
      { text: "Empresa", value: "empresa.nombre" },
      { text: "Teléfono", value: "telefono" },
      { text: "Error", value: "tipo" },
      { text: "Fecha", value: "fecha" },
      { text: "Acción" }
    ]
  }),
  watch: {
    // search2(data) {
    //   this.busqinit(data);
    // },
    menu1(val) {
      val && setTimeout(() => (this.$refs.menu1.activePicker = 'YEAR'));
    },
    menu2(val) {
      val && setTimeout(() => (this.$refs.menu2.activePicker = 'YEAR'));
    },
    dateStart() {
      if (this.dateStart && this.dateEnd) {
        if (new Date(this.dateStart) > new Date(this.dateEnd)) {
          this.snackbar = {
            message: 'La fecha inicial no puede ser mayor que la fecha final',
            color: 'error',
            show: true
          };
          this.dateStart = null;
          return;
        }
      }
    },
    dateEnd() {
      if (this.dateStart && this.dateEnd) {
        if (new Date(this.dateStart) > new Date(this.dateEnd)) {
          this.snackbar = {
            message: 'La fecha final no puede ser menor que la fecha inicial',
            color: 'error',
            show: true
          };
          this.dateEnd = null;
          return;
        }
      }
    }
  },
  mounted() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);
    
    // Establecer fechas por defecto
    this.dateStart = yesterday.toISOString().split('T')[0];
    this.dateEnd = today.toISOString().split('T')[0];
    
    // Asegurar que los datepickers muestren las fechas correctamente
    this.$nextTick(() => {
      if (this.$refs.menu1) {
        this.$refs.menu1.save(this.dateStart);
      }
      if (this.$refs.menu2) {
        this.$refs.menu2.save(this.dateEnd);
      }
    });
    
    // Cargar datos iniciales
    this.initialize(false);
  },
  methods: {
    clearDates() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      
      this.dateStart = yesterday.toISOString().split('T')[0];
      this.dateEnd = today.toISOString().split('T')[0];
      
      this.$nextTick(() => {
        if (this.$refs.menu1) {
          this.$refs.menu1.save(this.dateStart);
        }
        if (this.$refs.menu2) {
          this.$refs.menu2.save(this.dateEnd);
        }
        this.initialize(false);
      });
    },
    saveDate(picker) {
      if (picker === 1) {
        this.$refs.menu1.save(this.dateStart);
        this.menu1 = false;
      } else {
        this.$refs.menu2.save(this.dateEnd);
        this.menu2 = false;
      }
    },
    cancelDate(picker) {
      if (picker === 1) {
        this.dateStart = null;
        this.menu1 = false;
      } else {
        this.dateEnd = null;
        this.menu2 = false;
      }
    },
    buscarPorFechas() {
      this.initialize(true);
    },
    seleccion(item) {
      this.dialog3 = true;
      const dateParams = this.dateStart && this.dateEnd ? `&start=${this.dateStart}&end=${this.dateEnd}` : '';
      Api.get(`errores/pag?search=${this.search2}&id=${item}&empresa=${this.empresaSel}${dateParams}`)
        .then(res => {
          this.dialog3 = false;
          this.max = res.data.max;
          this.skip = this.max - res.data.resultados.length;
          this.errores = res.data.resultados;
          for (let i = 1; i <= res.data.paginas; i++) {
            this.paginas.push(i);
          }
          document
            .getElementById("num" + this.actual)
            .setAttribute(
              "style",
              "background-color:gainsboro;border-radius:50%;"
            );
          document.getElementById("next").hidden = false;
          document.getElementById("prev").hidden = false;
          if (this.skip === 0) {
            document.getElementById("prev").hidden = true;
          }
          if (res.data.tope === true) {
            document.getElementById("next").hidden = true;
          }
          let a = item;
          this.listado = [];
          for (let i = 0; i < 4; i++) {
            if (a <= res.data.pag) {
              this.listado.push(a);
            }
            a++;
          }
          this.$nextTick(() => {
            this.actual = item;
            this.selpag = item;
            if (
              this.listado.length > 0 &&
              document.getElementById("num" + this.actual)
            ) {
              document
                .getElementById("num" + this.actual)
                .setAttribute(
                  "style",
                  "background-color:#adadad;border-radius:50%;"
                );
            }
          });
        })
        .catch(err => {
          console.log(err);
          this.dialog3 = false;
        });
    },
    prev() {
      let info = {
        max: this.skip,
        ult: false,
        num: null
      };
      let dat = this.actual - 1;
      if (dat < this.listado[0]) {
        info.ult = true;
        info.num = dat;
      }
      this.dialog3 = true;
      const dateParams = this.dateStart && this.dateEnd ? `&start=${this.dateStart}&end=${this.dateEnd}` : '';
      Api.post(`errores/prev?search=${this.search2}&empresa=${this.empresaSel}${dateParams}`, info)
        .then(res => {
          this.total = res.data.total;
          if (res.data.resultados.length > 0) {
            this.paginas = [];
            this.max = res.data.max + 20;
            this.skip = res.data.max;
            this.errores = res.data.resultados;
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            document.getElementById("next").hidden = false;
            if (res.data.tope === true) {
              document.getElementById("prev").hidden = true;
            }
          }
          if (info.ult) {
            let a = this.listado[0] - 5;
            this.listado = [];
            if (a < 0) {
              a = 0;
              document.getElementById("prev").hidden = true;
            }
            for (let i = 0; i < 4; i++) {
              a++;
              if (a <= res.data.pag) {
                this.listado.push(a);
              }
            }
            this.$nextTick(() => {
              this.actual = this.actual - 1;
              this.selpag = this.actual;
              if (this.listado.length > 0 && document.getElementById("num"+this.actual)) {
                document.getElementById("num"+this.actual).setAttribute("style", "background-color:#adadad;border-radius:50%;");
                if (document.getElementById("num"+(this.actual-1))) {
                  document.getElementById("num"+(this.actual-1)).setAttribute("style", "background-color:gainsboro;border-radius:50%;");
                }
                if (document.getElementById("num"+(this.actual-2))) {
                  document.getElementById("num"+(this.actual-2)).setAttribute("style", "background-color:gainsboro;border-radius:50%;");
                }
                if (document.getElementById("num"+(this.actual-3))) {
                  document.getElementById("num"+(this.actual-3)).setAttribute("style", "background-color:gainsboro;border-radius:50%;");
                }
              }
            });
          } else {
            document.getElementById("num"+this.actual).setAttribute("style", "background-color:gainsboro;border-radius:50%;");
            this.actual = this.actual - 1;
            this.selpag = this.actual;
            document.getElementById("num"+this.actual).setAttribute("style", "background-color:#adadad;border-radius:50%;");
          }
          this.dialog3 = false;
        })
        .catch(err => {
          this.dialog3 = false;
          console.log(err);
        });
    },
    next() {
      let info = {
        max: this.max,
        ult: false,
        num: null
      };
      let dat = this.actual + 1;
      if (dat > this.listado[this.listado.length - 1]) {
        info.ult = true;
        info.num = dat;
      }
      this.dialog3 = true;
      const dateParams = this.dateStart && this.dateEnd ? `&start=${this.dateStart}&end=${this.dateEnd}` : '';
      Api.post(`errores/next?search=${this.search2}&empresa=${this.empresaSel}${dateParams}`, info)
        .then(res => {
          this.total = res.data.total;
          if (res.data.resultados.length > 0) {
            this.max = res.data.max;
            this.skip = this.max - res.data.resultados.length;
            this.errores = res.data.resultados;
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            document.getElementById("prev").hidden = false;
            if (res.data.tope === true) {
              document.getElementById("next").hidden = true;
            }
          }
          if (info.ult) {
            let a = this.listado[this.listado.length - 1];
            this.listado = [];
            for (let i = 0; i < 4; i++) {
              a++;
              if (a <= res.data.pag) {
                this.listado.push(a);
              }
            }
            this.$nextTick(() => {
              this.actual = this.actual + 1;
              this.selpag = this.actual;
              if (this.listado.length > 0 && document.getElementById("num"+this.actual)) {
                document.getElementById("num"+this.actual).setAttribute("style", "background-color:#adadad;border-radius:50%;");
                if (document.getElementById("num"+(this.actual+3))) {
                  document.getElementById("num"+(this.actual+3)).setAttribute("style", "background-color:gainsboro;border-radius:50%;");
                }
                if (document.getElementById("num"+(this.actual+2))) {
                  document.getElementById("num"+(this.actual+2)).setAttribute("style", "background-color:gainsboro;border-radius:50%;");
                }
                if (document.getElementById("num"+(this.actual+1))) {
                  document.getElementById("num"+(this.actual+1)).setAttribute("style", "background-color:gainsboro;border-radius:50%;");
                }
              }
            });
          } else {
            document.getElementById("num"+this.actual).setAttribute("style", "background-color:gainsboro;border-radius:50%;");
            this.actual = this.actual + 1;
            this.selpag = this.actual;
            document.getElementById("num"+this.actual).setAttribute("style", "background-color:#adadad;border-radius:50%;");
          }
          this.dialog3 = false;
        })
        .catch(err => {
          this.dialog3 = false;
          console.log(err);
        });
    },
    busqinit(item) {
      document.getElementById("prev").hidden = true;
      document.getElementById("next").hidden = false;
      const dateParams = this.dateStart && this.dateEnd ? `&start=${this.dateStart}&end=${this.dateEnd}` : '';
      Api.get(`errores/skip?search=${item}&empresa=${this.empresaSel}${dateParams}`)
        .then(res => {
          this.errores = [];
          this.listado = [];
          this.total = res.data.total;
          for (let i = 0; i < res.data.resultados.length; i++) {
            this.errores.push(res.data.resultados[i]);
          }
          this.max = this.errores.length;
          if (this.max === 0) {
            this.skip = 0;
            document.getElementById("next").hidden = true;
          } else {
            if (this.max < 20) {
              this.skip = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.skip = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            this.$nextTick(() => {
              if (this.listado.length > 0 && document.getElementById("num1")) {
                document
                  .getElementById("num1")
                  .setAttribute("style", "background-color:#adadad;border-radius:50%;");
              }
              if (document.getElementById("num2")) {
                document.getElementById("num2").setAttribute("style", "background-color:gainsboro;border-radius:50%;");
              }
              if (document.getElementById("num3")) {
                document.getElementById("num3").setAttribute("style", "background-color:gainsboro;border-radius:50%;");
              }
              if (document.getElementById("num4")) {
                document.getElementById("num4").setAttribute("style", "background-color:gainsboro;border-radius:50%;");
              }
            });
            this.actual = 1;
            this.selpag = 1;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    viewSMS(item) {
      this.dialog2 = true;
      this.sms = item.mensaje;
    },
    initialize(police) {
      this.dialog3 = true;
      this.listado = [];
      this.actual = 0;
      this.max = 0;
      this.skip = 0;
      if (!police) {
        this.empresas = [];
        this.empresaSel = null;
      }
      const dateParams = this.dateStart && this.dateEnd ? `&start=${this.dateStart}&end=${this.dateEnd}` : '';
      Api.get(`errores/skip?search=${this.search2}&empresa=${this.empresaSel}${dateParams}`)
        .then(res => {
          this.dialog3 = false;
          this.errores = res.data.resultados;
          this.paginas = [];
          this.total = res.data.total;
          this.max = res.data.resultados.length;
          if (this.max === 0) {
            this.skip = 0;
            document.getElementById("next").hidden = true;
          } else {
            for (let i = 1; i <= res.data.paginas; i++) {
              this.paginas.push(i);
            }
            if (this.max < 20) {
              this.skip = 0;
              document.getElementById("next").hidden = true;
            } else {
              this.skip = this.max - 20;
            }
            for (let i = 0; i < res.data.pag; i++) {
              this.listado.push(i + 1);
            }
            this.$nextTick(() => {
              if (this.listado.length > 0 && document.getElementById("num1")) {
                document
                  .getElementById("num1")
                  .setAttribute("style", "background-color:#adadad;border-radius:50%;");
              }
            });
            this.selpag = 1;
            this.actual = 1;
          }
        })
        .catch(err => {
          console.log(err);
          this.dialog3 = false;
        });
      if (!police) {
        Api.get("empresa").then(res => {
          this.empresas.push( {
            text: "Todas",
            value: null
          })
          if (res.data && res.data.length > 0) {
            res.data.forEach(el => {
              this.empresas.push( {
                text: el.nombre,
                value: el._id
              })
            });
          }
        });
      }
    }
  }
};
</script>

<style>
.v-date-picker-header,
.v-date-picker-table th,
.v-date-picker-table button {
  color: white !important;
}

.v-date-picker-header .v-date-picker-header__value button {
  color: white !important;
}

.v-date-picker-table .v-btn__content {
  color: white !important;
}

.v-picker.v-card {
  background-color: #1E1E1E !important;
}

.v-date-picker-header__value {
  color: white !important;
}

.v-date-picker-table .v-btn.v-btn--active {
  background-color: white !important;
  color: #1E1E1E !important;
}

.v-date-picker-table .v-btn.v-btn--active .v-btn__content {
  color: #1E1E1E !important;
}
</style>